import React from "react";
//outsource
import { Row, Col, Space, Button } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
//components
import TimeUserSearch from "./component/time_search_user";
import TimeShow from "./component/time_show";

//redux
import { useDispatch, useSelector } from "react-redux";
import { setEdit, setOpen } from "../../../store/report/report.action";
import { company } from "../../../store/report/report.selector";

const TimeControl = ({ userId, setUserId }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const companyId = useSelector(company);
  const disabled = companyId === null ? true : false;
  // -------------------------- FUNCTION --------------------------
  const handleEdit = () => {
    dispatch(setEdit({ data: true }));
  };

  const handleAddNew = () => {
    dispatch(setOpen({ data: true }));
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderTimeSearch = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={11} lg={11} md={24} xs={24}>
          <TimeUserSearch setUserId={setUserId} userId={userId} />
        </Col>
        <Col xl={8} lg={8} md={24} xs={24}>
          <TimeShow />
        </Col>
      </Row>
    );
  };

  const renderGroupButton = () => {
    return (
      <Space>
        <Button
          icon={<PlusOutlined />}
          style={{
            backgroundColor: disabled ? "gray" : "green",
            color: "white",
            border: 0,
          }}
          type="primary"
          onClick={handleAddNew}
          disabled={disabled}
        >
          Add Record
        </Button>
        <Button
          icon={<EditOutlined />}
          type="primary"
          onClick={handleEdit}
          disabled={disabled}
        >
          Edit
        </Button>
      </Space>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={16} lg={16} md={24} xs={24}>
        {renderTimeSearch()}
      </Col>
      <Col align="right" xl={8} lg={8} md={24} xs={24}>
        {renderGroupButton()}
      </Col>
    </Row>
  );
};

export default TimeControl;
